import { FunctionComponent, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { StoryCardThreadContent } from '../../../services';
import { FeedCardProps } from '../../../shared';
import { FeedCardPreviewContent } from '../FeedCardPreviewContent';
import { FeedCardPreviewWrapper } from '../FeedCardPreviewWrapper';

export const FeedCardPreviewThread: FunctionComponent<FeedCardProps> = memo(({ card }) => {
  const { t } = useTranslation();

  const { localiseKey } = useContext(ConfigContext).config.elements.card.thread;

  const { title } = card.content as StoryCardThreadContent;

  return (
    <FeedCardPreviewWrapper card={card}>
      <FeedCardPreviewContent
        source={t(`${localiseKey ?? 'common.discussion'}`)}
        title={title}
      ></FeedCardPreviewContent>
    </FeedCardPreviewWrapper>
  );
});
